@if (loc()) {
<ng-container *ngIf="(inlineEnabled$ | async) !== true; else inlining">
	<ng-container
		*ngIf="
			!(
				(hideOn() === 'emptyString' && loc()?.value === '') ||
				(hideOn() === 'null' && loc()?.value === null)
			)
		">
		<div
			*ngIf="loc()?.htmlAllowed"
			class="cm-localized-content"
			[innerHtml]="loc()?.safeHtml || loc()?.value | safeHtml"
			[attr.data-loc]="name()"
			[style]="customStyle() ?? ''"></div>
		<!-- eslint-disable-next-line max-len -->
		<span *ngIf="!loc()?.htmlAllowed" [attr.data-loc]="name()" [style]="customStyle() ?? ''">{{
			loc()?.value
		}}</span>
	</ng-container>
</ng-container>

<ng-template #inlining>
	<cm-inlining-localization
		[locName]="loc()?.name"
		[customInliningStyle]="customInliningStyle()"></cm-inlining-localization>
</ng-template>
}
